// extracted by mini-css-extract-plugin
export default {"container":"AccountSuspended_container__AUZRE","infoContainer":"AccountSuspended_infoContainer__npFU0","info":"AccountSuspended_info__cgLB1"};